@import 'src/global/media_queries'
  
:host 
  display: block

ul
  display: flex
  padding: 0
  justify-content: center
  align-items: center

  ::slotted(li)
    display: block
    padding: 0 0.5rem !important
    font-weight: 600 !important
    font-size: var(--fs-sm) !important
    color: inherit !important

    @include media(">=tablet")
      font-size: var(--fs-s) !important